import React, { useState, useEffect, memo, useRef } from 'react'
import ReactDOM from 'react-dom'
import * as d3 from 'd3'
import moment from 'moment'
import { Col, Row, Table } from 'antd'
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons'
import LineGraph from '../../graph/linegraph'
import { getGraphMeasurementData } from '../../../store/action/device.action'
import { connect } from 'react-redux'
import _ from 'lodash'
import util from '../../../util/util'
import { DataViewToggle } from '../../graph/chartDataView'
import { formatDateET, formatDateTimeET } from '../../../util/datetime'

// One device measurement series: the D3 line chart with its own DATA VIEW
// toggle that swaps in the Date / value grid. Kept as its own component so the
// toggle state survives the parent's re-renders.
const DeviceChartCard = ({ className, chart, table }) => {
  const [view, setView] = useState('chart')
  return (
    <Col flex='49%' className={className}>
      <Row justify='end' style={{ marginTop: 10, marginBottom: 4, paddingRight: 20 }}>
        <DataViewToggle
          active={view === 'data'}
          onClick={() => setView(view === 'data' ? 'chart' : 'data')}
        />
      </Row>
      {view === 'data' ? table : chart}
    </Col>
  )
}

const Graph = (props) => {
  const [graphData, setGraphData] = useState()

  useEffect(() => {
    getData()
  }, [])
  var getData = async () => {
    props.isLoading(true)
    var res = await props.getGraphMeasurementData(
      props.dev.patientid,
      props.dev.deviceid,
      10
    )
    // var data = res.data.map(i => ({...i,values:i.values.slice(-10)}));
    console.log('Graph data', res.data)
    setGraphData([...res.data])
    props.isLoading(false)
  }

  const formatMeasurementDate = (date) => {
    if (!date) return
    const dayPart = date.split(' ')[0]
    return dayPart
    // return moment(dayPart, 'MM/DD');
  }

  const getGraphDateWithYear = (dateStr) => {
    try {
      if (!dateStr && dateStr.split(' ') < 2) return null

      const year = moment().year()
      const arr = dateStr.split(' ') // 09/17 Mor
      const combinedDate = `${arr[0]}/${year}`
      const formattedDate = moment(combinedDate)
      return formattedDate.format('MM/DD/YYYY')
    } catch (err) {
      console.log('Error in date formatting', dateStr)
    }
    return null
  }

  const sanatizeGraphData = (data) => {
    console.log('sanatizeGraphData', data)
    let sanatizedData = []
    if (_.isEmpty(data)) return sanatizedData
    let values = JSON.parse(JSON.stringify(data.data[0].values))
    //console.log(values)
    data.data.forEach((d, idx) => {
      if (idx == 0) return
      d.values.forEach((v, idxv) => {
        //console.log(values,v,idxv)
        values[idxv].y[values[idxv].y.length - 1] += '/' + v.y[v.y.length - 1]
      })
    })
    return _.compact(values)
  }

  // Each reading carries a real timestamp in `xTime` (ISO) plus a bucketed
  // label `x` like "09/17 Mor" used by the chart. Prefer `xTime` so the table
  // shows the ET reading time; fall back to the date-only label (then the raw
  // label) when no real timestamp is present.
  const columns = [
    {
      title: 'Date',
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        const ka = a.xTime || getGraphDateWithYear(a.x) || a.x
        const kb = b.xTime || getGraphDateWithYear(b.x) || b.x
        return new Date(ka).getTime() - new Date(kb).getTime()
      },
      render: (data) => {
        if (!data) return 'NA'
        if (data.xTime) return formatDateTimeET(data.xTime)
        const withYear = getGraphDateWithYear(data.x)
        return withYear ? formatDateET(withYear) : formatMeasurementDate(data.x)
      },
    },
    {
      title: props.dev.metric_name
        ? props.dev?.metric_name[0].toUpperCase() +
          props.dev?.metric_name.slice(1).replace('_', ' ')
        : '',
      render: (data) => {
        return !_.isEmpty(data.y) && data.y[data.y.length - 1]
          ? data.y[data.y.length - 1]
          : 'NA'
      },
    },
  ]

  const viewTable = (data) => (
    <div style={{ padding: 10, margin: 15 }}>
      <Table
        columns={columns}
        dataSource={sanatizeGraphData(data)}
        showHeader
        bordered
        pagination={{ pageSize: 10, hideOnSinglePage: true, size: 'small' }}
        style={{ width: '80%', borderWidth: 2, padding: 10 }}
      />
    </div>
  )

  return graphData ? (
    graphData.map((d, i) =>
      (props.dev.parameter && d.data[0].reading == props.dev.parameter) ||
      !props.dev.parameter ? (
        <DeviceChartCard
          key={d._id + '' + i}
          className={props.hideBorder ? '' : 'chartContainer'}
          chart={
            <LineGraph
              fixed={true}
              data={{ ...d, _id: d._id + '' + i }}
              width={props.width}
            />
          }
          table={viewTable(d)}
        />
      ) : null
    )
  ) : (
    <></>
  )
}
const mapDispatchToProps = (dispatch) => {
  return {
    getGraphMeasurementData: (pid, did, count) =>
      dispatch(getGraphMeasurementData(pid, did, count)),
  }
}
const mapStateToProps = (state) => {
  return
}

export default connect(mapStateToProps, mapDispatchToProps)(Graph)
